// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__buG0s","activeTab":"Tab_activeTab__AuI8q"};